module.exports = __webpack_public_path__ + "img/p3-p1-text.ad8eef2b.png";